<div class="customDialouge" [ngClass]="data?.cssClass">
  <h1 mat-dialog-title class="title" *ngIf="data.heading">{{ data.heading }}</h1>
  <div mat-dialog-content class="content">{{ data.content }}</div>
  <div class="formGroup shrinkFix" *ngIf="data.remarksHeading !== undefined">
    <label>{{ data.remarksHeading.trim() === "" ? "Remarks" : data.remarksHeading }}<sup *ngIf="data.remarksMandatory">*</sup></label>
    <mat-form-field appearance="outline">
      <textarea matInput [(ngModel)]="userRemarks" placeholder="Enter remarks"></textarea>
    </mat-form-field>
  </div>
  <div mat-dialog-actions class="footerButtons">
    <button mat-button mat-dialog-close class="btnCustom btn-outline" (click)="myMethod(false)">{{ data.btnCancel }}</button>
    <button mat-button mat-dialog-close class="btnCustom btn-primary" [disabled]="isdisabled()" (click)="myMethod(true)">
      {{ data.btnConfirm }}
    </button>
  </div>
</div>
